export enum MarkupFormValue {
  PERCENTAGE = 'Percentage',
  DESCRIPTION = 'Description',
}
